// guarda en su estado todos los cursos para evitar llamadas repetitivas
import React, {useState} from "react";
import {ListByEssential, ListByPrime, ListByCourseType, ListByEmblem, SingleCourseInfo} from "../services/CoursesServices";
import {
   ListResourcesCourses,
   ThemaryCoursesService,
   FacilitatorsCourseService,
   TestimonialCourseService,
} from "../services/GeneralServices";
import {ListFacilitatorsService} from "../services/FacilitatorsService";
import {orderDataByTag} from "../constants/Helpers";

export const CoursesContext = React.createContext();

export default function CoursesProvider({children}) {
   const [essential, setEssential] = useState({isLoading: true, offer: [], head: {}});
   const [primeData, setPrime] = useState({isLoading: true, offer: [], head: {}});
   const [primeMaster, setPrimeMaster] = useState({isLoading: true, offer: [], head: {}});
   const [emblem, setEmblem] = useState({isLoading: true, offer: [], head: {}});
   const [courseData, setCourseData] = useState({isLoading: true}); // información de un curso (vista en detalle);
   const [themaryCourse, setThemaryCourse] = useState({isLoading: true, data: []});
   const [mediaCourse, setMediaCourse] = useState({isLoading: true, data: []});
   const [docsCourse, setDocsCourse] = useState({isLoading: true, data: []});
   const [facilitatorsCourse, setFsacilitatorsCourse] = useState({isLoading: true, data: []});
   const [listWebFacilitators, setFacilitators] = useState({isLoading: true, data: []});
   const [testimonialsList, setTestimonials] = useState({isLoading: true, data: []});

   function getEssential(force = false) {
      if (essential.offer.length > 1 && !force) return false;
      ListByEssential()
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            let newcourses = data.filter((cour) => cour.visible);
            setEssential({...essential, offer: [...newcourses], isLoading: false});
         })
         .catch((e) => {
            console.log(e);
         });
   }
   function getPrime(force = false) {
      if (primeData.offer.length > 1 && !force) return false;
      // offeer
      ListByPrime()
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            let newcourses = data.filter((cour) => cour.visible);
            setPrime({...primeData, offer: [...newcourses], isLoading: false});
         })
         .catch((e) => {
            console.log(e);
         });
   }
   function getPrimeMaster(force = false) {
      if (primeMaster.offer.length > 1 && !force) return false;
      // offeer
      ListByCourseType(5)
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            let newcourses = data.filter((cour) => cour.visible);
            setPrimeMaster({...primeMaster, offer: [...newcourses], isLoading: false});
         })
         .catch((e) => {
            console.log(e);
         });
   }
   function getEmblem(force = false) {
      if (emblem.offer.length > 1 && !force) return false;
      ListByEmblem()
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            let newcourses = data.filter((cour) => cour.visible);
            // console.log(data);
            // console.log(newcourses);
            setEmblem({...emblem, offer: [...newcourses], isLoading: false});
         })
         .catch((e) => {
            console.log(e);
         });
   }

   function getInfoCourse(id) {
      let singleCourseE = essential.offer.find((cour) => Number(cour.idCourse) === Number(id));
      let singleCoursePri = primeData.offer.find((cour) => Number(cour.idCourse) === Number(id));
      let singleCouseMa = primeMaster.offer.find((cour) => Number(cour.idCourse) === Number(id));

      let singleCourse = singleCourseE || singleCoursePri || singleCouseMa;
      // console.log(singleCourse);
      if (singleCourse) {
         return setCourseData({...singleCourse, isLoading: false});
      }

      SingleCourseInfo(id)
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            // console.log(data[0]);
            setCourseData({...data[0], isLoading: false});
         })
         .then(() => {
            getResourses(id);
         })
         .catch((e) => {
            console.log(e);
         });
   }

   function getResourses(id) {
      ListResourcesCourses(id)
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            let pdfFile = data.filter((doc) => doc.resourceType === "pdf");
            setDocsCourse({isLoading: false, data: [...pdfFile]});
            let videoFiles = data.filter((doc) => doc.resourceType === "video");
            setMediaCourse({isLoading: false, data: [...videoFiles]});
         })
         .catch((e) => {
            console.log(e);
            setDocsCourse({isLoading: false, data: []});
            setMediaCourse({isLoading: false, data: []});
         });
   }

   function getThemary(id) {
      // console.log("LLamr", id);
      ThemaryCoursesService(id)
         .then((res) => res.json())
         .then((resp) => {
            let {status, data} = resp;
            if (status === "error") throw new Error();
            let toPrint = orderDataByTag(data, "idTemaryClasses");
            setThemaryCourse({isLoading: false, data: [...toPrint]});
         })
         .catch((e) => {
            console.log(e);
         });
   }

   function getFacilitators(id) {
      // console.log("BUSca", id);
      FacilitatorsCourseService(id)
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            // console.log(resp);
            if (status === "error") throw new Error();
            let faciList = data.map((item) => {
               let dataF = listWebFacilitators.data.find((fac) => Number(fac.idFacilitator) === Number(item.idFacilitator));
               // console.log(dataF);
               return {...item, ...dataF};
            });
            // console.log(faciList[0]);
            setFsacilitatorsCourse({isLoading: false, data: [...faciList]});
         })
         .catch((e) => {
            console.log(e);
            setFsacilitatorsCourse({isLoading: false, data: []});
         });
   }

   function getInfoFacilitators(force = false) {
      if (listWebFacilitators.length > 0 && !force) return false;
      ListFacilitatorsService()
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            setFacilitators({isLoading: false, data: [...data]});
         })
         .catch((e) => {
            setFacilitators({isLoading: false, data: []});
            console.log(e);
         });
   }

   const getExperiencesList = (id) => {
      TestimonialCourseService(id)
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            setTestimonials({isLoading: false, data: [...data]});
         })
         .catch((e) => {
            setTestimonials({isLoading: false, data: []});
            console.log(e);
         });
   };

   return (
      <CoursesContext.Provider
         value={{
            // cursos esenciales
            getEssential,
            essential,
            // prime
            primeData,
            getPrime,
            // prime masterclass
            getPrimeMaster,
            primeMaster,
            // emblem
            getEmblem,
            emblem,
            // detalles de curso
            getInfoCourse,
            courseData,
            //
            mediaCourse,
            docsCourse,
            // temaerio
            getThemary,
            themaryCourse,
            // facilitatoes
            getInfoFacilitators, // datos de todos los facilitadores
            listWebFacilitators, // datos de todos los facilitadores
            getFacilitators,
            facilitatorsCourse,
            // experiencia ---testiomonials
            getExperiencesList,
            testimonialsList,
         }}
      >
         {children}
      </CoursesContext.Provider>
   );
}
